<template>
    <div class="home">
        <div class="left">
            <Hamburger v-if="this.$store.state.user.role.label == 'secretaire'"/>
            <DropdownNav v-if="this.$store.state.user.role.label == 'moniteur'"/>
            <h1 class="site-title" @click="goToHome"><span>Mon</span>permis.<span>fr</span></h1>
        </div>
        <img src="../../assets/images/logoMonPermis.png" alt="">
        <div class="user-badge">
            <div class="avatar" :class="{ clickable: isEleve }" @click="goToDonneePerso">{{user.charAt(0)}}</div>
            <div class="user-info">
                <div class="name" :class="{ clickable: isEleve }" @click="goToDonneePerso">{{user}}</div>
                <div class="status" @click="deconnexion">Se déconnecter</div>
            </div>
        </div>
    </div>
</template>
<script>
import DropdownNav from '../DropdownNav.vue';
import Hamburger from '../Hamburger.vue';

export default {
    props: ["user"],

    components: {
        Hamburger,
        DropdownNav
    },

    computed: {
        isEleve() {
            return this.$store.state.user.role.label == 'eleve';
        }
    },

    methods: {
        goToDonneePerso() {
            if (!this.isEleve) return;
            this.$router.push({ name: "DonneePerso", params: { personalData: 'true' } });
        },

        deconnexion() {
            this.$store.commit("setUser", null);
            this.$store.commit("setToken", null);
            localStorage.removeItem("user_info");
            localStorage.removeItem("user_access");
            this.$router.push({name: 'index'});
        },

        goToHome(){
            this.$router.push({ name: "Home" });
        }

    },

}
</script>
<style scoped>

    div.left{
        display: flex;
    }

    div.home{
        width: 100vw;
        height: 5vh;
        max-height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;
        background-color: white;
        border-bottom: 1px solid #E2E8F0;
        padding-left: 10px;
        padding-right: 10px;
    }
    div.home h1.site-title{
        font-weight: bold;
        font-size: 2rem;
        cursor: pointer;
    }

    div.home h1.site-title span{
        color: #6899f5;
    }

    div.home img{
        height: 90%;   /* ou 100% si tu veux */
        width: auto;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
    }


    div.home .user-badge {
        display: flex;
        align-items: center;
        height: 80%;
        padding: 1rem;
    }

    div.home .avatar {
        width: 40px;
        height: 40px;
        background-color: #3a86ff;
        color: white;
        font-weight: bold;
        font-size: 18px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        margin-right: 10px;
    }

    div.home .user-info {
        display: flex;
        flex-direction: column;
    }

    div.home .name {
        font-size: 16px;
        font-weight: bold;
        color: #000;
        text-align: left;
    }

    div.home .clickable {
        cursor: pointer;
    }

    div.home .status {
        font-size: 12px;
        color: #666;
        cursor: pointer;
        text-align: left;
    }

    div.home .status:hover{
        color: #888888;
    }

    @media (max-width: 1000px){
        img{
            display: none;
        }
    }

</style>